import { NavLink, useLocation } from "react-router-dom";
import { publicUrlFor } from "../../../globals/constants";
import { useState, useEffect } from "react";

function Header() {

    const [isActive, setIsActive] = useState(false);
    const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    // Close mobile menu and submenu when route changes
    useEffect(() => {
        setIsActive(false);
        setIsSubmenuOpen(false);
    }, [location.pathname]);

    // Handle scroll for sticky header background
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    function toggleNavClass () {
        setIsActive(!isActive)
    }

    function toggleSubmenu(e) {
        e.preventDefault();
        setIsSubmenuOpen(!isSubmenuOpen);
    }

    function closeMenu() {
        setIsActive(false);
        setIsSubmenuOpen(false);
    }

    return (
        <header className={"site-header header-style-3 mobile-sider-drawer-menu " + (isActive ? "active " : "") + (isScrolled ? "scrolled" : "")}>
            {/* Mobile Menu Overlay */}
            {isActive && (
                <div
                    className="mobile-menu-overlay"
                    onClick={closeMenu}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 9,
                        display: 'block'
                    }}
                />
            )}

            <div className="sticky-header main-bar-wraper  navbar-expand-lg">
                <div className="main-bar">

                    <div className="container-fluid clearfix">

                        <div className="logo-header">
                            <div className="logo-header-inner logo-header-one">
                                <NavLink to="/">
                                    <img src={publicUrlFor("/assets/images/nivian_hdr_logo.png")} alt="" />
                                </NavLink>
                            </div>
                        </div>

                        {/* NAV Toggle Button */}
                        <button
                            id="mobile-side-drawer"
                            type="button"
                            className="navbar-toggler collapsed"
                            onClick={toggleNavClass}
                        >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar icon-bar-first"></span>
                            <span className="icon-bar icon-bar-two"></span>
                            <span className="icon-bar icon-bar-three"></span>
                        </button>

                        {/* MAIN Nav */}
                        <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">

                            {/* Mobile Menu Header */}
                            <div className="mobile-menu-header">
                                <div className="mobile-menu-logo">
                                    <NavLink to="/" onClick={closeMenu}>
                                        <img src={publicUrlFor("/assets/images/nivian_hdr_logo.png")} alt="Nivian 3PL" />
                                    </NavLink>
                                </div>
                            </div>

                            <ul className="nav navbar-nav">
                                <li><NavLink to="/">Home</NavLink></li>
                                <li><NavLink to="/services">Services</NavLink></li>
                                <li><NavLink to="/contact-us">Contact</NavLink></li>
                                <li><NavLink to="/about-us">About Us</NavLink></li>
                                <li className={"has-child" + (isSubmenuOpen ? " nav-active" : "")}>
                                    <span className="nav-link" onClick={toggleSubmenu} style={{ cursor: 'pointer' }}>
                                        More
                                        <i className={`fa fa-chevron-${isSubmenuOpen ? 'up' : 'down'}`} style={{ marginLeft: '8px', fontSize: '12px' }}></i>
                                    </span>
                                    <ul className="sub-menu" style={isSubmenuOpen ? { display: 'block' } : {}}>
                                        <li><NavLink to="/locations">Locations</NavLink></li>
                                        <li><NavLink to="/faq">FAQ</NavLink></li>
                                        <li><NavLink to="/news">News</NavLink></li>
                                        <li><NavLink to="/3pl-glossary">3PL Glossary</NavLink></li>
                                    </ul>
                                </li>
                            </ul>

                            {/* Mobile Menu Footer */}
                            <div className="mobile-menu-footer">
                                <div className="mobile-menu-contact">
                                    <a href="tel:8183961116" className="mobile-menu-phone">
                                        <i className="fa fa-phone"></i>
                                        <span>818-396-1116</span>
                                    </a>
                                    <a href="mailto:info@nivian3pl.com" className="mobile-menu-email">
                                        <i className="fa fa-envelope"></i>
                                        <span>info@nivian3pl.com</span>
                                    </a>
                                </div>
                            </div>

                        </div>

                        {/* Header Right Section */}
                        <div className="extra-nav header-2-nav">
                            <div className="extra-cell">
                                <div className="header-search">
                                    <a href="#search" className="header-search-icon"><i className="fa fa-search"></i> </a>
                                </div>
                            </div>
                            <div className="extra-cell">
                                <div className="header-nav-call-section">


                                    <div className="detail">
                                        <span className="title">Contact Us</span>
                                        <span><a href="tel:8183961116">818-396-1116</a></span>
                                    </div>
                                    <div className="media">
                                        <i id="phone-icon" className="fa fa-phone"></i>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>


                </div>

                {/* SITE Search */}
                <div id="search">
                    <span className="close"></span>
                    <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
                        <input className="form-control" name="q" type="search" placeholder="Type to search" />
                        <span className="input-group-append">
                            <button type="button" className="search-btn">
                                <i className="fa fa-paper-plane"></i>
                            </button>
                        </span>
                    </form>
                </div>
            </div>

        </header>
    )
}

export default Header;